import { useParams, Link, Navigate } from "react-router-dom";
import { SERVICES } from "@/lib/constants";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { useSEO } from "@/lib/useSEO";

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = SERVICES.find((s) => s.slug === slug);
  useSEO({
    title: service ? `${service.title} · ScholarPrintHub` : undefined,
    description: service ? `${service.tagline} — offered by ScholarPrintHub with proper citation support, formatting, and printing/binding in India.` : undefined,
    keywords: service ? `${service.title.toLowerCase()}, ${service.slug}, academic services india, thesis support, ${service.slug.replace(/-/g, " ")}` : undefined,
  });
  if (!service) return <Navigate to="/services" replace />;

  return (
    <div data-testid={`service-detail-${service.slug}`} className="container-app py-20">
      <Link to="/services" className="text-xs section-eyebrow hover:underline">← All services</Link>
      <div className="grid lg:grid-cols-12 gap-10 mt-6">
        <div className="lg:col-span-8">
          <h1 className="font-display text-4xl sm:text-5xl text-navy">{service.title}</h1>
          <div className="divider-gold mt-4 mb-6" />
          <p className="text-slate-600 max-w-2xl">{service.tagline}</p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {service.bullets.map((b, i) => (
              <li key={i} className="flex gap-2 text-sm text-slate-700 border border-slate-200 rounded-sm p-3">
                <CheckCircle2 className="w-4 h-4 text-gold shrink-0 mt-0.5" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link data-testid="detail-request" to="/academic-request" className="btn-primary">Request this service <ArrowRight className="w-4 h-4" /></Link>
            <Link to="/upload" className="btn-outline">Upload existing file</Link>
            <Link to="/calculator" className="btn-gold">Check printing cost</Link>
          </div>
        </div>
        <aside className="lg:col-span-4">
          <div className="border border-slate-200 rounded-sm p-6 bg-slate-50">
            <div className="section-eyebrow">Ethical positioning</div>
            <p className="mt-2 text-sm text-slate-700">
              We provide academic <strong>support</strong>: editing, formatting, citation correction, plagiarism review, and printing.
              Final material is intended for learning, reference, and documentation support in accordance with your institution&apos;s policies.
            </p>
          </div>
          <div className="border border-slate-200 rounded-sm p-6 mt-4">
            <div className="section-eyebrow">Delivery</div>
            <p className="mt-2 text-sm text-slate-700">
              Final Word/PDF is shared over email; printed hard-bound copies are couriered anywhere in India with tracking.
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
}
